import { render, staticRenderFns } from "./CMAttachmentFilter.vue?vue&type=template&id=71f95d6e&"
import script from "./CMAttachmentFilter.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f95d6e')) {
      api.createRecord('71f95d6e', component.options)
    } else {
      api.reload('71f95d6e', component.options)
    }
    module.hot.accept("./CMAttachmentFilter.vue?vue&type=template&id=71f95d6e&", function () {
      api.rerender('71f95d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CMAttachmentFilter.vue"
export default component.exports